import React,{useEffect} from "react";
import { PayPalButtons, PayPalScriptProvider } from "@paypal/react-paypal-js";
import { toFormatPrice } from "pos/common/helpers/function";
const PayPalButton = ({
  paymentdatashow,
  userdata,
  payamount,
  currency,
  setCreditpaymentdata,
  onPaymentSuccess,
  customer_id,
  creditCardDetails,
  setcreditCardDetails,
  amount,
}) => {
  // Ensure client ID is available
//     useEffect(() => {
//   if (creditCardDetails?.payment && creditCardDetails?.transID) {
//     onPaymentSuccess();
//   }
// }, [creditCardDetails]);
  const clientId = creditCardDetails?.key || "AeJHMorrvj5SklB9nvyR-RGzGLlrKoi3xyz9jLf3HjRfn9KIy7DmXtHU4WQakl20oTMvj2wIwLszdJte";

  // Format amount as string with 2 decimals
//  const formattedAmount =
//   amount && Number(amount) > 0
//     ? Number(amount).toFixed(2)
//     : null;
const formattedAmount = Number(amount).toFixed(2);
    console.log(amount,"formattedAmount")

  // Only render PayPal if clientId is available
  if (!clientId) {
    return <div>Loading payment options...</div>;
  }

  const initialOptions = {
    "client-id": clientId,
    currency: currency || "USD",
    intent: "capture",
  };

  return (
    <PayPalScriptProvider options={initialOptions}>
      <PayPalButtons
        style={{ layout: "vertical" }}
        createOrder={(data, actions) => {
          return actions.order.create({
            purchase_units: [
              {
                amount: {
                  currency_code: currency || "USD",
                  value: formattedAmount,
                },
              },
            ],
          });
        }}
        onApprove={(data, actions) => {
          return actions.order.capture().then((details) => {

            setcreditCardDetails((state) => ({
              ...state,
              payment: true,
              transID:details.purchase_units[0].payments.captures[0].id
            }));

            onPaymentSuccess(details.purchase_units[0].payments.captures[0].id,true);
          });
        }}
        onError={(err) => {
          console.error("PayPal error:", err);
        }}
      />
    </PayPalScriptProvider>
  );
};

export default PayPalButton;
